/* eslint-disable no-undef */
switch (process.env.NODE_ENV) {
default:
case 'development': {
    break;
}
case 'testing': {
    // Workaround: selenium logs retrieved by nightwatch only show first variable passed, compress and pass to original function
    ['log', 'warn', 'error'].forEach(name => {
        const func = console[name];
        console[name] = function (...str) {
            const message = str
                .map(item => {
                    if (typeof(item) === 'object') {
                        // extended use, with pretty print, indent level 2
                        item = JSON.stringify(item, null, 4);
                    }
                    return item;
                })
                .join(' ');
            func(message);
        };
    });
    break;
}
case 'production': {
    // Disable all logging in production
    ['log', 'warn', 'error'].forEach(name => {
        console[name] = function () {
        };
    });
    break;
}
}



// WEBPACK FOOTER //
// ./src/logging/index.js